import { channelId } from '../data/config'

// 获取渠道id
export function getChannelId (name) {
  return channelId
}
// 根据url地址参数名获取参数名对应的值
export function getUrlKey (name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
        location.href
      ) || [, ''])[1].replace(/\+/g, '%20')
    ) || null
  )
}
// 返回首页
export function gotoHomeFn (instance) {
  instance.$router.push({
    name: 'Home'
  })
}

// 像素转rem
export function px2rem (num) {
  const clientWidth = document.documentElement.clientWidth
  const htmlFontSize =
      document.querySelector('html').style['font-size'] &&
      parseInt(document.querySelector('html').style['font-size'])
  const reg = clientWidth / 375 / htmlFontSize
  return num * reg
}

// 验证姓名
export function checkFullName (str, firstUpper) {
  let ret = str.toLowerCase()
  ret = ret.replace(/_([\w+])/g, function (all, letter) {
    return letter.toUpperCase()
  })
  if (firstUpper) {
    ret = ret.replace(/\b(\w)(\w*)/g, function ($0, $1, $2) {
      return $1.toUpperCase() + $2
    })
  }
  return ret
}
// 验证邮箱 /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
export function checkEmail (email) {
  let re = /^([a-zA-Z0-9]+[_|-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|-|.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,3}$/
  return re.test(email)
}
// 验证手机号
export function checkPhone (phone) {
  return /^1[3456789]\d{9}$/.test(phone)
}

// 信用卡安全隐藏中间*
export function aBankCard (bankcard) {
  let reg = /^(\d{4})\d+(\d{4})$/
  return bankcard.replace(reg, '$1 **** **** $2')
}
// 验证护照编号
// 大陆护照
export function checkPassport (checkPassportCode) {
  let reg = /(^[EeKkGgDdSsPpHh]\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$)/
  return reg.test(checkPassportCode)
}
// 验证身份证后8位
export function checkIDCard8 (IDcardNo) {
  let reg = /((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]/
  return reg.test(IDcardNo)
}
// 验证身份证号合法性
export function checkIDCard (code) {
  // 支持15位和18位身份证号
  // 支持地址编码、出生日期、校验位验证
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }
  var row = true
  if (
    !code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(
          code
        )
  ) {
    row = false
  } else if (!city[code.substr(0, 2)]) {
    row = false
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      if (parity[sum % 11] != code[17].toUpperCase()) {
        row = false
      }
    }
  }
  return row
}



// WEBPACK FOOTER //
// ./src/utils/index.js